window.addEventListener('load', function () {

 gsap.registerPlugin(ScrollTrigger);
  gsap.fromTo('.fadein-left1',
    { x: -100, autoAlpha: 0 },
    {
      x: 0,
      autoAlpha: 1,
      duration: 1,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: '.fadein-left1',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein',
    { autoAlpha: 0 },
    {
      autoAlpha: 1,
      duration: 1,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: '.fadein',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-scale1',
    { scale: 0, autoAlpha: 0 },
    {
      scale: 1,
      autoAlpha: 1,
      duration: 1,
      ease: 'power2.out',
      stagger: 0.2,
      scrollTrigger: {
        trigger: '.fadein-scale1',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-delay1',
    { autoAlpha: 0 },
    {
      autoAlpha: 1,
      duration: 1.5,
      ease: 'power2.out',
      delay: .3,
      scrollTrigger: {
        trigger: '.fadein-delay1',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-delay2',
    { autoAlpha: 0 },
    {
      autoAlpha: 1,
      duration: 1.5,
      ease: 'power2.out',
      delay: .5,
      scrollTrigger: {
        trigger: '.fadein-delay2',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-right1',
    { x: 100, autoAlpha: 0 },
    {
      x: 0,
      autoAlpha: 1,
      duration: 1,
      ease: 'power2.out',
      delay: .5,
      stagger: 0.5,
      scrollTrigger: {
        trigger: '.fadein-right1',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-up1',
    { y: 40, autoAlpha: 0 },
    {
      y: 0,
      autoAlpha: 1,
      duration: .5,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: '.fadein-up1',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-up2',
    { y: 40, autoAlpha: 0 },
    {
      y: 0,
      autoAlpha: 1,
      duration: .5,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: '.fadein-up2',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-left2',
    { x: -100, autoAlpha: 0 },
    {
      x: 0,
      autoAlpha: 1,
      duration: 1,
      ease: 'power2.out',
      stagger: 0.1,
      scrollTrigger: {
        trigger: '.fadein-left2',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-right2',
    { x: 100, autoAlpha: 0 },
    {
      x: 0,
      autoAlpha: 1,
      duration: 1,
      ease: 'power2.out',
      delay: .5,
      stagger: 0.3,
      scrollTrigger: {
        trigger: '.fadein-right2',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-right3',
    { x: 100, autoAlpha: 0 },
    {
      x: 0,
      autoAlpha: 1,
      duration: 1,
      ease: 'power2.out',
      delay: .5,
      stagger: 0.3,
      scrollTrigger: {
        trigger: '.fadein-right3',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-right4',
    { x: 100, autoAlpha: 0 },
    {
      x: 0,
      autoAlpha: 1,
      duration: 1,
      ease: 'power2.out',
      delay: .5,
      stagger: 0.3,
      scrollTrigger: {
        trigger: '.fadein-right4',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-scale2',
    { scale: 0, autoAlpha: 0 },
    {
      scale: 1,
      autoAlpha: 1,
      duration: 1,
      ease: 'power2.out',
      delay: 1.5,
      scrollTrigger: {
        trigger: '.fadein-scale2',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true,
        onEnter: () => {
          const bounce = () => {
            gsap.fromTo('.fadein-scale2 img',      // ← 内部のSVG画像を対象
              { y: 0 },
              {
                y: -20,           // 上に20px
                duration: 0.4,
                ease: 'power1.out',
                yoyo: true,
                repeat: 1         // 上下1往復
              }
            );
          };

          bounce(); // すぐ1回実行
          setInterval(bounce, 5000);
        }
      }
    }
  );

  gsap.fromTo('.fadein-left3',
    { x: -100, autoAlpha: 0 },
    {
      x: 0,
      autoAlpha: 1,
      duration: 1,
      ease: 'power2.out',
      delay: .5,
      stagger: 0.3,
      scrollTrigger: {
        trigger: '.fadein-left3',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-scale3',
    { scale: 0, autoAlpha: 0 },
    {
      scale: 1,
      autoAlpha: 1,
      duration: 1,
      ease: 'power2.out',
      delay: 1.5,
      scrollTrigger: {
        trigger: '.fadein-scale3',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-scale4',
    { scale: 0, autoAlpha: 0 },
    {
      scale: 1,
      autoAlpha: 1,
      duration: 1,
      ease: 'power2.out',
      delay: 1,
      scrollTrigger: {
        trigger: '.fadein-scale4',
        start: 'top 90%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.slide-mask', 
    { scaleX: 1 },
    {
      scaleX: 0,
      ease: 'power4.inOut',
      duration: 1.5,
      scrollTrigger: {
        trigger: '.slide-mask',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-up3',
    { y: 40, autoAlpha: 0 },
    {
      y: 0,
      autoAlpha: 1,
      duration: .5,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: '.fadein-up3',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-delay3',
    { autoAlpha: 0 },
    {
      autoAlpha: 1,
      duration: 1.5,
      ease: 'power2.out',
      delay: .3,
      scrollTrigger: {
        trigger: '.fadein-delay3',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-up4',
    { y: 40, autoAlpha: 0 },
    {
      y: 0,
      autoAlpha: 1,
      duration: .5,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: '.fadein-up4',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-down1',
    { y: -100, autoAlpha: 0 },
    {
      y: 0,
      autoAlpha: 1,
      duration: .3,
      ease: 'power2.out',
      delay: .4,
      scrollTrigger: {
        trigger: '.fadein-up4',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-left4',
    { x: -100, autoAlpha: 0 },
    {
      x: 0,
      autoAlpha: 1,
      duration: 1,
      ease: 'power2.out',
      delay: .5,
      stagger: 0.3,
      scrollTrigger: {
        trigger: '.fadein-left4',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-scale5',
    { scale: 0, autoAlpha: 0 },
    {
      scale: 1,
      autoAlpha: 1,
      duration: 1,
      ease: 'power2.out',
      delay: .5,
      scrollTrigger: {
        trigger: '.fadein-scale5',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-up5',
    { y: 40, autoAlpha: 0 },
    {
      y: 0,
      autoAlpha: 1,
      duration: .5,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: '.fadein-up5',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-delay4',
    { autoAlpha: 0 },
    {
      autoAlpha: 1,
      duration: 1.5,
      ease: 'power2.out',
      delay: .3,
      stagger: 0.3,
      scrollTrigger: {
        trigger: '.fadein-delay4',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-delay5',
    { autoAlpha: 0 },
    {
      autoAlpha: 1,
      duration: 1.5,
      ease: 'power2.out',
      delay: .3,
      stagger: 0.3,
      scrollTrigger: {
        trigger: '.fadein-delay5',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-delay6',
    { autoAlpha: 0 },
    {
      autoAlpha: 1,
      duration: 1.5,
      ease: 'power2.out',
      delay: .3,
      stagger: 0.3,
      scrollTrigger: {
        trigger: '.fadein-delay6',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-left5',
    { x: -100, autoAlpha: 0 },
    {
      x: 0,
      autoAlpha: 1,
      duration: 1,
      ease: 'power2.out',
      delay: .5,
      stagger: 0.3,
      scrollTrigger: {
        trigger: '.fadein-left5',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );

  gsap.fromTo('.fadein-scale6',
    { scale: 0, autoAlpha: 0 },
    {
      scale: 1,
      autoAlpha: 1,
      duration: 1,
      ease: 'power2.out',
      delay: .5,
      scrollTrigger: {
        trigger: '.fadein-scale6',
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true
      }
    }
  );




  
});